import { Lightbulb } from "lucide-react";
import { useAdvisor } from "./advisor/useAdvisor";
import { AdvisorChat } from "./advisor/AdvisorChat";
import { AdvisorSidebar } from "./advisor/AdvisorSidebar";

const AdvisorView = () => {
  const a = useAdvisor();
  return (
    <div className="space-y-6" data-testid="advisor-view">
      <div>
        <h1 className="text-2xl text-white mb-2 flex items-center gap-2">
          <Lightbulb className="h-6 w-6 text-ism-teal" />
          <span className="text-ism-teal">AI Advisor</span>
        </h1>
        <p className="text-sm text-gray-500">Strategic guidance for your sales process</p>
      </div>
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
        <div className="lg:col-span-2">
          <AdvisorChat messages={a.messages} input={a.input} setInput={a.setInput} loading={a.loading} scrollRef={a.scrollRef} onSend={a.send} />
        </div>
        <AdvisorSidebar onPick={a.setInput} />
      </div>
    </div>
  );
};

export default AdvisorView;
